export default class SslSupportService {
  /*@ngInject*/
  constructor() {
    this.DISABLE_MODE = 'disable';
    this.TLS_MODE = 'tls';

    this.SERVER_CERT_STORAGE_TYPE_KEYSTORE = 'keystore';
    this.SERVER_CERT_STORAGE_TYPE_PRIVATE_KEY_AND_CERT = 'privateKeyAndCert';
  }
}



// WEBPACK FOOTER //
// ./src/blocks/ssl-support-service/ssl-support-service.js